import { css } from '@emotion/css';
import React from 'react';
import { TitleHeader, TitleHeaderProps } from 'src/components/shared/TitleHeader';
import { OwnedPointHead } from './OwnedPointHead';

type FortunePageLayoutProps = Pick<
  TitleHeaderProps,
  'title' | 'backLabel' | 'hintLabel' | 'hintPath'
> & { background?: string };

export const FortunePageLayout: React.FC<FortunePageLayoutProps> = ({
  title,
  backLabel,
  hintPath,
  hintLabel,
  background,
  children
}) => {
  return (
    <main
      className={css`
        width: 100%;
        height: 100%;
        overflow: hidden;
        background: ${background ? background : 'inherit'};
      `}
    >
      <TitleHeader
        title={title}
        color="#e0f4ba"
        backLabel={backLabel}
        hintPath={hintPath}
        hintLabel={hintLabel}
      >
        <OwnedPointHead />
      </TitleHeader>
      <div
        className={css`
          height: calc(100% - 116px);
          overflow: auto;
        `}
      >
        {children}
      </div>
    </main>
  );
};
